<script lang="ts" setup>
  import type { CmsPageBlockJsonldDefaultRead } from '@/api'
  import PanelDefault from '@/elements/PanelDefault.vue'
  import { toRef } from 'vue'

  interface Props {
    blocks: CmsPageBlockJsonldDefaultRead[]
  }

  const props = defineProps<Props>()
  const blocks = toRef<CmsPageBlockJsonldDefaultRead[]>(props.blocks)

  function block(idx: number): string {
    return blocks.value[idx].content ?? ''
  }
</script>

<template>
  <div>
    <PanelDefault>
      <div
        class="overflow-x-scroll"
        v-html="block(0)" />
    </PanelDefault>
    <div class="grid grid-cols-[33%_66%] gap-2">
      <PanelDefault>
        <div
          class="overflow-x-scroll"
          v-html="block(1)" />
      </PanelDefault>
      <PanelDefault>
        <div
          class="overflow-x-scroll"
          v-html="block(2)" />
      </PanelDefault>
    </div>
  </div>
</template>
